// extracted by mini-css-extract-plugin
module.exports = {"root":"massActions_root__3vcgP"};